import React, { useEffect } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import SAPEventRegistration from "./SAPEventRegistration";

const SAPEventRegister = () => {
  useEffect(() => {
    document.title =
      "WA | SAP Event Registration | Society of Aquaculture Professionals";
  }, []);
  return (
    <>
      <Header />
      <SAPEventRegistration />
      <Footer />
    </>
  );
};

export default SAPEventRegister;
